module.exports = __webpack_public_path__ + "img/icon-tabbar-my-active.683cd463.png";